/*

Author: David Biga - All rights reserved - 2015

Description:  This is the core file that handles our rendering to user screen

*/
import { server } from '../../engine/server'
import THREE from 'particlespace-graphics-engine'
import THREEx from 'particlespace-graphics-engine-extensions'
import { browserHistory } from 'react-router';

import {cameraHandler} from './CameraHandler';
import {roomRenderer} from './RoomRenderer';
import {sensorRenderer} from './SensorRenderer';
import {floorPlanRenderer} from './FloorPlanRenderer';
import {spaces} from '../../controllers/Spaces'
import {sensors} from '../../controllers/Sensors'

	// handles our rendering of all of our objects
var LevelRenderer = Class.create({// variables: container => camera => scene => renderer => plane => mouse => raycaster => isShiftDown  => cubeGeometry => cubeMaterial => cubeTmpHoverMaterial => colorNormal => colorHover => colorTmpHover => colorRemove = >  blocks => tmpBlocks
	initialize: function() {
		this.offsetY = 0;
	},
  	init: function(levelHandler) {
		  // #  Update levelRenderer to levelRenderer
  		this.levelHandler = levelHandler;
		// setup our local vars

		//var container;
		var camera = cameraHandler,room = roomRenderer, sensorHandler = sensorRenderer, scene, renderer;
		var plane;
		var editMode = false;
		var mouse, raycaster, isShiftDown = false;
		var controls;
		/*var cubeGeometry = new THREE.BoxGeometry( 50, 50, 50 );// moving to roomObj
		var cubeMaterial = new THREE.MeshLambertMaterial( { color: 0x00ff80, overdraw: 0.5 } ); // moving to roomObj
		var cubeTmpHoverMaterial = new THREE.MeshLambertMaterial({ color: 0x00ff80, transparent: true, opacity:0.5});// used to give a transparency to the cube tmp view // moving to roomObj*/
		var blocks = [];
		var rooms = []; // used to just store rooms added
		var sensorsArray = [];
		var tmpBlocks = []; // used for when hovering over plane
		
		//<!-- setup our screen to hold everything and send to canvasObj -->
		//container = document.getElementById( 'canvas_hold' );
		this.camera = camera;//this.floorGrid[2]; // moved to camera.js - cameraObj

		/*var info = document.createElement( 'div' );
		info.style.position = 'absolute';
		info.style.top = '10px';
		info.style.width = '100%';
		info.style.textAlign = 'center';
		info.innerHTML = 'Particle Space <a href="javascript:save()">save .png</a>';
		container.appendChild( info );*/
		
		
		// <!-- Setup our camera -->
		/*camera = new THREE.PerspectiveCamera( 40, window.innerWidth / window.innerHeight, 1, 10000 );
		camera.position.set( 500, 800, 1300 );
		camera.lookAt( new THREE.Vector3() );
		*/
		
		//<!-- Setup our Scene -->
		/*scene = new THREE.Scene();
		

		//<!-- Setup our grid -->

		this.createGridWireFrame();

		var size = 500, step = 50;

		var geometry = new THREE.Geometry();

		for ( var i = - size; i <= size; i += step ) {

			geometry.vertices.push( new THREE.Vector3( - size, 0, i ) );
			geometry.vertices.push( new THREE.Vector3(   size, 0, i ) );

			geometry.vertices.push( new THREE.Vector3( i, 0, - size ) );
			geometry.vertices.push( new THREE.Vector3( i, 0,   size ) );

		}

		var material = new THREE.LineBasicMaterial( { color: 0x000000, opacity: 0.2 } );

		var line = new THREE.Line( geometry, material, THREE.LinePieces );
		scene.add( line );

		//

		raycaster = new THREE.Raycaster();
		mouse = new THREE.Vector2();

		var geometry = new THREE.PlaneBufferGeometry( 1000, 1000 );
		geometry.applyMatrix( new THREE.Matrix4().makeRotationX( - Math.PI / 2 ) );
		geometry.computeBoundingBox();
		plane = new THREE.Mesh( geometry );
		plane.visible = false;
		scene.add( plane );

		blocks.push( plane );

		var material = new THREE.MeshBasicMaterial( { color: 0xff0000, wireframe: false } );
		
		// Lights

		var ambientLight = new THREE.AmbientLight( 0x606060 );
		scene.add( ambientLight );
		
		// add direction of lighting where sun is - in future - LEAVE RANDOM FOR NOW
		var directionalLight = new THREE.DirectionalLight( 0xffffff );
		directionalLight.position.x = Math.random() - 0.5;
		directionalLight.position.y = Math.random() - 0.5;
		directionalLight.position.z = Math.random() - 0.5;
		directionalLight.position.normalize();
		scene.add( directionalLight );

		var directionalLight = new THREE.DirectionalLight( 0x808080 );
		directionalLight.position.x = Math.random() - 0.5;
		directionalLight.position.y = Math.random() - 0.5;
		directionalLight.position.z = Math.random() - 0.5;
		directionalLight.position.normalize();
		scene.add( directionalLight );

		renderer = new THREE.CanvasRenderer();
		renderer.setClearColor( 0xffffff );//0xf0f0f0
		//renderer.setPixelRatio( window.devicePixelRatio ); // fix this - not scaling like it should provide
		// #  We need to dynamically set our width
		renderer.setSize( window.innerWidth, window.innerHeight )
				
		container.appendChild(renderer.domElement);*/
		

		mouse = new THREE.Vector2();

		// #  SEtup our grid
		this.createGridWireFrame();
		
		this.renderer = this.floorGrid[0];
		this.scene = this.floorGrid[2];
		this.room = room;
		this.roomRenderer = roomRenderer;
		this.sensorHandler = sensorHandler;
		this.underLineGrid = this.floorGrid[3];
		this.gridFrame = this.floorGrid[5];
		this.mouse = mouse;
		this.raycaster = this.floorGrid[4];
		this.outOfBoundsPlane = this.floorGrid[6];
		this.isShiftDown = isShiftDown;
		this.activeWindowTimeout = [];
		//this.cubeGeometry = cubeGeometry;
		//this.cubeMaterial = cubeMaterial;	MOVED TO ROOMOBJ
		//this.cubeTmpHoverMaterial = cubeTmpHoverMaterial;
		blocks.push( this.outOfBoundsPlane );
		blocks.push( this.underLineGrid );
		blocks.push( this.gridFrame );

		this.blocks = blocks;
		this.sensorsArray = sensorsArray;
		this.rooms = rooms;
		this.activeSensors = [];
		this.tmpBlocks = tmpBlocks;
		this.editMode = editMode;
		this.isMouseDown = false;
		this.outOfBounds = false;
		this.lastSpace = null;
		this.didOpenUnitOverview = false;
		//dom holder
		this.domEvents   = new THREEx.DomEvents(this.camera.cam, this.renderer.domElement);
		
		// #  Controls are key to our rotation and zooming
		controls = new THREE.OrbitControls(this.camera.cam,this.renderer.domElement);
		controls.addEventListener( 'change', this.render.bind(this),false );
		controls.enableZoom = true;
		// #  Disable pan (hold both mouse buttons and drag)
		controls.enablePan = false;
		controls.minDistance = 100;
		controls.maxDistance = 1600;
		controls.maxPolarAngle = 1.5;
		// #  Store locally
		this.controls = controls;
		// variables: container => camera => scene => renderer => plane => mouse => raycaster => isShiftDown  => cubeGeometry => cubeMaterial => colorNormal => colorHover =>  blocks => tmpBlocks
		// #  Attach our renderer to our container
		//this.container.appendChild(this.renderer.domElement);
		var stateObject = {updateCanvas: true, renderer: this.renderer};
		this.levelHandler.updateState(stateObject);
		// #  Set resize bool
		this.isResizing = null;
		window.addEventListener('scroll', this.onWindowScroll.bind(this), true);
  	},
	initActionListeners: function() {
		// container listeners
		this.container = document.getElementById("level-overview");
		this.container.addEventListener( 'mousedown', this.onDocumentMouseDown.bind(this), false );
		this.container.addEventListener( 'mouseover', this.onDocumentMouseOver.bind(this), false );
		this.container.addEventListener( 'mousemove', this.onDocumentMouseMove.bind(this), false );
		this.container.addEventListener( 'mouseout', this.onDocumentMouseOut.bind(this), false );
		this.container.addEventListener( 'keydown', this.onDocumentKeyDown.bind(this), true );
		this.container.addEventListener( 'keyup', this.onDocumentKeyUp.bind(this), false );
		// window resizing
		window.addEventListener( 'resize', this.onWindowResize.bind(this), false );
	},
	destroyActionListeners: function(){
		// container listeners
		this.container.removeEventListener( 'mousedown', this.onDocumentMouseDown.bind(this), false );
		this.container.removeEventListener( 'mouseover', this.onDocumentMouseOver.bind(this), false );
		this.container.removeEventListener( 'mousemove', this.onDocumentMouseMove.bind(this), false );
		this.container.removeEventListener( 'mouseout', this.onDocumentMouseOut.bind(this), false );
		this.container.removeEventListener( 'keydown', this.onDocumentKeyDown.bind(this), true );
		this.container.removeEventListener( 'keyup', this.onDocumentKeyUp.bind(this), false );
		// window resizing
		window.removeEventListener( 'resize', this.onWindowResize.bind(this), false );
	},
	onWindowResize: function() {
		var computedHeight = (jQuery("#main").height() - jQuery("#main nav").height());
        var shaveOff = computedHeight * .1;
        computedHeight = computedHeight - shaveOff;;

        var height = computedHeight;
        var width = jQuery("#main").width();
		// #  Setup the new aspects
		this.camera.cam.aspect = width / height;
		this.camera.cam.updateProjectionMatrix();
		// #  Set our renderer
		this.renderer.setSize( width, height );
		// #  Set our dom events camera
		this.domEvents.camera(this.camera.cam);
		// #  render sceen
		this.render();
	},
	onWindowScroll: function(e) {
		if(jQuery(e.target).parent().parent().parent().parent().hasClass('single-task-card')) {
			return;
		}
		this.offsetY = e.srcElement.scrollTop;
		this.domEvents.addScrollOffset(this.offsetY);
	},
	onWindowResizeAnimatedOpen: function(subractionWidth) {
		// #  We are passing in a percent, lets turn this into a px
		var pixels = window.innerWidth*(subractionWidth/100);
		// #  Get our containers width and height based on if our spaceoverview window is open
		var width = window.innerWidth - pixels + 15; // #  Add on multple []
		var height = window.innerHeight;
		// #  Setup the new aspects
		this.camera.cam.aspect = width / height;
		this.camera.cam.updateProjectionMatrix();
		// #  Set our renderer
		this.renderer.setSize( width, height );
		// #  Set our dom events camera
		this.domEvents.camera(this.camera.cam);
		// #  render sceen
		this.render();
	},
	onWindowResizeAnimatedClose: function(subractionWidth) {
		// #  Get our containers width and height based on if our spaceoverview window is open
		var width = window.innerWidth - subractionWidth + 15; // #  Add on multple []
		var height = window.innerHeight;
		// #  Setup the new aspects
		this.camera.cam.aspect = width / height;
		this.camera.cam.updateProjectionMatrix();
		// #  Set our renderer
		this.renderer.setSize( width, height );
		// #  Set our dom events camera
		this.domEvents.camera(this.camera.cam);
		// #  render sceen
		this.render();
	},
	onWindowResizeDone: function() {
		// #  Rebind primary events
		/*this.destroyActionListeners();
		this.initActionListeners();
		// #  Remove old action listeners
		this.removeSpaceActionListeners();
		// #  Add new action listeners
		for(var i = 0; i < this.rooms.length; i++)
		{
			var space = this.rooms[i];

			this.domEvents.addEventListener(space, 'mouseover', this.onDocumentMouseOverCube.bind(this),false);
			this.domEvents.addEventListener(space, 'mouseout', this.onDocumentMouseOutCube.bind(this),false);
			this.domEvents.addEventListener(space, 'click', this.onDocumentMouseOutClick.bind(this),false);
		}*/
		if(this.didOpenUnitOverview){
			this.didOpenUnitOverview = false;
		} else {
			this.didOpenUnitOverview = true;
		}
	},
	removeSpaceActionListeners: function() { 
		for(var i = 0; i < this.rooms.length; i++)
		{
			var space = this.rooms[i];

			this.domEvents.removeEventListener(space, 'mouseover', this.onDocumentMouseOverCube.bind(this),false);
			this.domEvents.removeEventListener(space, 'mouseout', this.onDocumentMouseOutCube.bind(this),false);
			this.domEvents.removeEventListener(space, 'click', this.onDocumentMouseOutClick.bind(this),false);

		}

		for(var i = 0; i < this.sensorsArray.length; i++)
		{
			var space = this.sensorsArray[i];

			this.domEvents.removeEventListener(space, 'mouseover', this.onDocumentMouseOverCube.bind(this),false);
			this.domEvents.removeEventListener(space, 'mouseout', this.onDocumentMouseOutCube.bind(this),false);
			this.domEvents.removeEventListener(space, 'click', this.onDocumentMouseOutSensorClick.bind(this),false);
		}

	},
	onDocumentMouseDown: function( event ) { // handle populating onto canvas screen
		  // #  Fixes bug related to unit editor not allowing inputs to be selected
		  if(this.didOpenUnitOverview){
			  return true;
		  }

		  event.preventDefault();
		  var self = this;
		  // #  Set variables for use in movement of camera
		  this.camera.onMouseDownTheta = this.theta;
		  this.camera.onMouseDownPhi = this.phi;
		  this.camera.onMouseDownPosition.x = event.layerX;
		  this.camera.onMouseDownPosition.y = event.layerY;
		  this.isMouseDown = true;

		  // #  Validate we are in edit mode
		  if(this.editMode == false)
		  {
		  	return;
		  }
		  // #  Validate we are not out of bounds
		  if(this.outOfBounds == true)
		  {
		  	return;
		  }
		  this.toggleRenderType();

		  this.mouse.x = ( event.layerX / this.renderer.domElement.width ) * 2 - 1;
		  this.mouse.y = - ( event.layerY / this.renderer.domElement.height ) * 2 + 1;

		  this.raycaster.setFromCamera( this.mouse, this.camera.cam );
  		  var intersects = this.raycaster.intersectObjects( this.blocks );
		  if ( intersects.length > 0 ) {
			  var intersect = intersects[ 0 ];
			  if ( this.isShiftDown ) { // see if shift is down to remove
				  if ( intersect.object != this.underLineGrid || intersect.object != this.gridFrame ) {
					this.scene.remove( intersect.object );

					this.blocks.splice( this.blocks.indexOf( intersect.object ), 1 );
					this.rooms.splice( this.rooms.indexOf( intersect.object ), 1 );
					this.render();
				  }
			  } else if(intersect.object == this.underLineGrid || intersect.object == this.gridFrame ){ // add room to canvas


					var voxel = new THREE.Mesh( this.room.cubeGeometry.clone(), this.room.cubeMaterial.clone() );
					voxel.geometry.computeBoundingBox();
					voxel.position.copy( intersect.point ).add( intersect.face.normal );
					voxel.position.divideScalar( this.room.divideScalar ).floor().multiplyScalar( this.room.multiplyScalar ).addScalar( this.room.addScalar );

					// now lets do some custom modification of position for objects to handle snapping effect
					voxel.position.z += this.room.additionalZ;
					voxel.position.x += this.room.additionalX;
					//lets do some addition to current object for different data paramters used for hovering 
					voxel.hoverColor = this.room.colorHover;
					voxel.colorNormal = this.room.colorNormal;
					voxel.colorRemove = this.room.colorRemove;
					voxel.roomID = this.room.roomID;
					voxel.roomType = this.room.roomType;
					// #  Set color
					voxel.material.color.setHex(voxel.colorNormal);

					var testObjOverlap = this.checkOverlapObject(voxel); // lets send to see if we are overlapping any objects
					if(testObjOverlap)
					{
						if(this.sensorHandler.isActive) {
							voxel.isSensor = true;
							this.sensorsArray.push(voxel);
						} else {
							this.blocks.push( voxel );
							this.rooms.push(voxel);
						}
						this.scene.add( voxel );
						this.render();
						//#  Lets send this new object to our server
						this.saveSpace(voxel, function(response) {
							voxel.spaceID = response.data.space_id;
							// DOM events for inside 3d rendering
							self.domEvents.addEventListener(voxel, 'mouseover', self.onDocumentMouseOverCube.bind(self),false);
							self.domEvents.addEventListener(voxel, 'mouseout', self.onDocumentMouseOutCube.bind(self),false);
							if(voxel.isSensor) {
								self.domEvents.addEventListener(voxel, 'click', self.onDocumentMouseOutSensorClick.bind(self),false);
							} else {
								self.domEvents.addEventListener(voxel, 'click', self.onDocumentMouseOutClick.bind(self),false);
							}
						});
					}
			  }
		  }
	  },
	  // # TODO: add in for loop to loop through each space and remove any colors
	clearColors: function() {
		if(this.lastSpace != null)
		{
			this.lastSpace.material.color.setHex(this.lastSpace.colorNormal);
		}
	},
	// #  Checks after editMode is disabled if, we have a active selected space
	checkSpaceOverViewActive: function() {
		if(this.lastSpace != null)
		{
			this.lastSpace.material.color.setHex(this.lastSpace.hoverColor);
		}
	},
	onDocumentMouseOutClick: function(event ) {
		// #  Make sure we are not in edit mode
		if(this.editMode){return;}
		// #  Check if we have an assigned last space
		if(this.lastSpace != null)
		{
			this.lastSpace.material.color.setHex(this.lastSpace.colorNormal);
		}
		// #  Set last space used
		this.lastSpace = event.target;
		// #  Set space to hover color
		if(event.target.sensorActive == 0) {
			event.target.material.color.setHex(event.target.hoverColor);
			this.render();
		}
		// #  Send to gui for loading of data
		this.levelHandler.loadSpaceOverView(event.target);
		// update route
		browserHistory.replace('/building/' + this.levelHandler.context.props.buildingID + '/level/' + this.levelHandler.context.props.levelID + '/space/' + event.target.spaceID);
	},
	onDocumentMouseOutSensorClick: function(event ) {
		// #  Make sure we are not in edit mode
		if(this.editMode){return;}
		if(this.lastSpace != null)
		{
			this.lastSpace.material.color.setHex(this.lastSpace.colorNormal);
		}
		this.lastSpace = event.target;

		if(event.target.alertActive == 0) {
			event.target.material.map = event.target.hoverColor;
		} else {
			event.target.material.map = event.target.colorAlert;
		}
		this.render();
		this.levelHandler.loadSensorOverview(event.target);
		browserHistory.replace('/building/' + this.levelHandler.context.props.buildingID + '/level/' + this.levelHandler.context.props.levelID + '/sensor/' + event.target.spaceID);
	},
	manualMouseOutClick: function(target) {
		// #  Make sure we are not in edit mode
		if(this.editMode){return;}
		// #  Check if we have an assigned last space
		if(this.lastSpace != null)
		{
			this.lastSpace.material.color.setHex(this.lastSpace.colorNormal);
		}
		// #  Set last space used
		this.lastSpace = target;
		// #  Set space to hover color
		target.material.color.setHex(target.hoverColor);
		this.render();
		// #  Send to gui for loading of data
		this.levelHandler.loadSpaceOverView(target);
	},
	manualMouseOutClickSensor: function(target) {
		// #  Make sure we are not in edit mode
		if(this.editMode){return;}
		// #  Check if we have an assigned last space
		if(this.lastSpace != null && this.lastSpace.uuid != target.uuid)
		{
			this.lastSpace.material.map = this.lastSpace.colorNormal;
			this.lastSpace.material.map.needsUpdate = true;
		}
		// #  Set last space used
		this.lastSpace = target;
		// #  Set space to hover color
		target.material.map = target.hoverColor;
		target.material.map.needsUpdate = true;
		this.render();
		// #  Send to gui for loading of data
		this.levelHandler.loadSensorOverview(target);
	},
	onDocumentMouseOver: function( event ) {
	
	},
	onDocumentMouseMove: function( event ) {
		// #  Lets reset our out of bounds
		this.outOfBounds = false;
		// #  Validate we are in edit mode
		if(this.editMode == false)
			return;

		this.toggleRenderType();

		this.mouse.x = ( event.layerX / this.renderer.domElement.width ) * 2 - 1;
		this.mouse.y = - ( event.layerY / this.renderer.domElement.height ) * 2 + 1;
		/*
		this.mouse.x = ( event.layerX / window.innerWidth ) * 2 - 1;
		this.mouse.y = - ( event.layerY / window.innerHeight ) * 2 + 1;*/
		this.raycaster.setFromCamera( this.mouse, this.camera.cam );
		
		var intersects = this.raycaster.intersectObjects( this.blocks );

		if ( intersects.length > 0 ) { // make sure we are not intersecting any object already on the plane
			var intersect = intersects[ 0 ];
			if(intersect.object == this.outOfBoundsPlane)
			{
				// #  Out of bounds
			}
			if (intersect.object != this.underLineGrid && intersect.object != this.gridFrame ) { 
				//do nothing

			} else if(intersect.object == this.underLineGrid || intersect.object == this.gridFrame) { 
				// remove old box
				for(var i = 0; i < this.tmpBlocks.length; i++)
				{
					this.scene.remove( this.tmpBlocks[i] );
					//this.tmpBlocks.splice( this.tmpBlocks.indexOf( this.tmpBlocks[i] ) );
					this.render();
				}
				this.tmpBlocks = [];
				// add tmp box
		  		var voxel = new THREE.Mesh( this.room.cubeGeometry, this.room.cubeTmpHoverMaterial );
				voxel.geometry.computeBoundingBox();
				voxel.position.copy( intersect.point ).add( intersect.face.normal );
				voxel.position.divideScalar( this.room.divideScalar ).floor().multiplyScalar( this.room.multiplyScalar ).addScalar( this.room.addScalar );
				// now lets do some custom modification of position for objects to handle snapping effect
				voxel.position.z += this.room.additionalZ;
				voxel.position.x += this.room.additionalX;
				
				//voxel.material.color.setHex(this.colorTmpHover);
				voxel.material.color.setHex(this.room.colorTmpHover);
				this.scene.add( voxel );
				this.tmpBlocks.push( voxel );
				this.render();
				var create = this.checkOverlapPlane(voxel,this.gridFrame);

 

				if(create)
				{
					var collision = this.checkOverlapPlane(voxel,this.gridFrame);// lets send to see if we are overlapping the plane - grid
					if(collision )
					{
						var testObjOverlap = this.checkOverlapObject(voxel); // lets send to see if we are overlapping any objects
						if(testObjOverlap)
						{
							//this.scene.add( voxel );
							//this.tmpBlocks.push( voxel );
							//var domEvents   = new THREEx.DomEvents(this.camera.cam, this.renderer.domElement);
							//voxel.material.color.setHex(this.room.colorTmpHover);
							//this.render();						
						}
						else
						{
							//this.scene.add( voxel );
							//this.tmpBlocks.push( voxel );
							//var domEvents   = new THREEx.DomEvents(this.camera.cam, this.renderer.domElement);
							voxel.material.color.setHex(this.room.colorRemove);
							this.render();
						}
					}
					
				}
				else
				{
					//this.scene.add( voxel );
					//this.tmpBlocks.push( voxel );
					//var domEvents   = new THREEx.DomEvents(this.camera.cam, this.renderer.domElement);
					voxel.material.color.setHex(this.room.colorRemove);
					this.render();
				}
			}
		}
		else
		{
			
		}
	},
	onDocumentMouseOverCube: function( event ) {
		// #  Validate we are not in edit mode
		if(this.editMode == true)
		  	return;

		if ( event.target != this.plane ) {
			// update color on hover
			if(event.target.isSensor) {
				if(event.target.alertActive == 1) {
					event.target.material.map = event.target.colorAlert;
				} else {
					event.target.material.map = event.target.hoverColor;
				}
				event.target.material.map.needsUpdate = true;
			} else {
				event.target.material.color.setHex(event.target.hoverColor);
			}
			this.render();
		}

	},
	onDocumentMouseOut: function( event ) {
	},
	onDocumentMouseOutCube: function( event) {
		// #  Validate we are not in edit mode
		if(this.editMode == true)
		{
		  	return;
		}
		if(this.lastSpace == event.target)
		{
			return;
		}
		if ( event.target != this.plane ) {
			// update color on hover
			if(event.target.isSensor) {
				if(event.target.alertActive == 1) {
					event.target.material.map = event.target.colorAlert;
				} else {
					event.target.material.map = event.target.colorNormal;
				}
				event.target.material.map.needsUpdate = true;
			} else {
				event.target.material.color.setHex(event.target.colorNormal);
			}
			this.render();
		}
	},
		onDocumentMouseUp: function( event) {
			event.preventDefault();
			this.isMouseDown = false;

			this.camera.onMouseDownPosition.x = event.layerX - this.onMouseDownPosition.x;
			this.camera.onMouseDownPosition.y = event.layerY - this.onMouseDownPosition.y;

			if ( this.camera.onMouseDownPosition.length() > 5 ) {
				return;
			}
		},
		onDocumentKeyDown: function( event ) {
			switch( event.keyCode ) {
				case 16: this.isShiftDown = true; break;
			}
		},
		onDocumentKeyUp: function( event ) {
			switch( event.keyCode ) {
  
				case 16: this.isShiftDown = false; break;
  
			}
		},
		save: function() {
	
			window.open( this.renderer.domElement.toDataURL('image/png'), 'mywindow' );
			return false;
	
		},
		updatePerspectiveCamera: function(){
			// change our perspecive
			this.camera.updatePerspectiveCamera();
			// get our new results
			this.camera = this.camera.reloadCamera();
			// reload our camera
			this.render();
			
		},
		checkOverlapPlane: function(voxel,plane) { // THIS IS USED TO TELL US IF WE ARE OUTSIDE THE GRIDS BOUNDRIES
			if(this.sensorHandler.isActive) {
				return true;
			}
			// #  First step is to check if anything internal goes over.
			for (var vertexIndex = 0; vertexIndex < voxel.geometry.vertices.length; vertexIndex++)
			{       
				
				//var adjustedVoxelPosition = voxel.position.clone();
				//adjustedVoxelPosition.y = 0;
			    var localVertex = voxel.geometry.vertices[vertexIndex].clone();
			    var globalVertex = localVertex.applyMatrix4( voxel.matrixWorld );
			    //var startVertext = globalVertex.clone();
			    //startVertext.y = startVertext.y - 50;
			    var directionVector = globalVertex.sub( voxel.position );//globalVertex;
			    //directionVector.y = directionVector.y + 50;

			    /*var material = new THREE.LineBasicMaterial({
					color: 0x0000ff
				});
				var geometry = new THREE.Geometry();
				geometry.vertices.push(voxel.position,
					directionVector.clone().normalize());

				var line = new THREE.Line( geometry, material );
				this.scene.add( line );*/

			    this.raycaster.set( voxel.position, directionVector.clone().normalize() );
			    var collisionResults =  this.raycaster.intersectObjects( this.blocks);
			    if ( collisionResults.length > 0 ) 
			    {
		
			    	var intersect = collisionResults[ 0 ];
			    	if(intersect.object == this.outOfBoundsPlane)
			    	{
			        	// a collision occurred... do something...
			        	this.outOfBounds = true;
			        	return false;
			    	}

			    }
			}
			// Now before doing anything lets check out min and max boundries to see if our x and z are either bigger or smaller
			/*var planeMX = plane.geometry.boundingBox.max.x;
			var planeMZ = plane.geometry.boundingBox.max.z;
			var planemX = plane.geometry.boundingBox.min.x;
			var planemZ = plane.geometry.boundingBox.min.z;
				//lets get our voxel min and max vars
			var voxelMX = voxel.geometry.boundingBox.max.x;
			var voxelMZ = voxel.geometry.boundingBox.max.z;
			var voxelmX = voxel.geometry.boundingBox.min.x;
			var voxelmZ = voxel.geometry.boundingBox.min.z;
				// we need to get our voxel position ad to do some math to see if voxel min and max do not go beyound our boundries for our plane
			var voxelPX = voxel.position.x;
			var voxelPZ = voxel.position.z;
				// lets do some calucation and condition
					// first lets turn everything over to positive for some easy calcuation
			voxelPX = Math.abs(voxelPX); // positions on world view
			voxelPZ = Math.abs(voxelPZ);
			
			voxelmZ = Math.abs(voxelmZ); // min and max values of our voxel
			voxelmX = Math.abs(voxelmX);
			voxelMZ = Math.abs(voxelMZ);
			voxelMX = Math.abs(voxelMX);
			
			planemZ = Math.abs(planemZ); // min and max values of our plane our voxels are on
			planemX = Math.abs(planemX);
			planeMZ = Math.abs(planeMZ);
			planeMX = Math.abs(planeMX);
				// now lets calucate X and Z to see if total goes over any of our planes min and max X or Z - remember everything is position but so we can add it to see if its above - we will not actually change the direct objects values
			var totalPositionVoxelminZ = (voxelPZ + voxelmZ);
			var totalPositionVoxelminX = (voxelPX + voxelmX);
			var totalPositionVoxelMAXZ = (voxelPZ + voxelMZ);
			var totalPositionVoxelMAXX = (voxelPX + voxelMX);
			
				// now lets compare
			if(totalPositionVoxelminZ > planemZ)
			{
				return false; // do nothing
			}
			else if(totalPositionVoxelminX > planemX)
			{
				return false; // do nothing
			}
			else if(totalPositionVoxelMAXZ > planeMZ)
			{
				return false; // do nothing
			}
			else if(totalPositionVoxelMAXX > planeMX)
			{
				return false; // do nothing
			}
			else
				return true;*/
			return true;
		},
		checkOverlapObject: function(voxel) // THIS IS USED TO SEE IF WE ARE OVER LAPPING ANY OBJECTS
		{
			if(this.sensorHandler.isActive) {
				return true;
			}
			//var originPoint = voxel.position.clone();
			var collidableObjs = this.rooms;
			//var tmpCollidableObjs = [];
			
			/*
			
				HAVE OUR RAY CASTER SHOOT FROM ABOVE THIS WAY THERE ARE NO INTERSECPTIONS FROM OBJECTS FATHER AWAY
			
			
			*/
			// Lets get our closes objects 
			/*for (var vertexIndex = 0; vertexIndex < voxel.geometry.vertices.length; vertexIndex++)
			{		
				var localVertex = voxel.geometry.vertices[vertexIndex].clone();
				var globalVertex = localVertex.applyMatrix4( voxel.matrix );
				
				var directionVector = globalVertex.sub( voxel.position );
				//var a = new THREE.Vector3( voxel.position.x, voxel.position.y, 0 );

				var ray = new THREE.Raycaster( voxel.position, directionVector.clone().normalize());
				/*var material = new THREE.LineBasicMaterial({
					color: 0x0000ff
				});
				
				var geometry = new THREE.Geometry(ray.ray.direction);
				geometry.vertices.push(
					directionVector,
					ray.ray.direction,
					ray.ray.origin
				);
				
				var line = new THREE.Line( geometry, material );
				this.scene.add( line );
				this.render();*
				
				var collisionResults = ray.intersectObjects( collidableObjs );
				if ( collisionResults.length > 0 && collisionResults[0].distance < directionVector.length() ) 
				{
					collisionResults[0].object.material.color.setHex(this.room.colorTmpHover);
					this.render();
				}
			}	*/
			
			var boxToCheck = new THREE.Box3().setFromObject(voxel);
			var boxCenterPoint = boxToCheck.center();
			//var halfDistanceX = (voxelMX + voxelmX);
			//var halfDistanceZ = (voxelMZ + voxelmZ);
			//var haflDistanceFromCenterX = (totalPositionVoxelMAXX - boxCenterPoint.x);
			for (var vertexIndex = 0; vertexIndex < voxel.geometry.vertices.length; vertexIndex++)
			{
				var localVertex = voxel.geometry.vertices[vertexIndex].clone();
				var globalVertex = localVertex.applyMatrix4( voxel.matrix );
				var tmpVertext = globalVertex.clone();
				var resetVertext = globalVertex.clone();
				//globalVertex.x -= 0.01;
				//globalVertex.y -= 0.01;
				//globalVertex.z -= 0.01;
				
				if(collidableObjs.length > 0)
				{
					for(var i = 0; i < collidableObjs.length; i++)
					{
						
						//lets get our voxel min and max vars
						/*var voxelMX = collidableObjs[i].geometry.boundingBox.max.x;
						var voxelMZ = collidableObjs[i].geometry.boundingBox.max.z;
						var voxelmX = collidableObjs[i].geometry.boundingBox.min.x;
						var voxelmZ = collidableObjs[i].geometry.boundingBox.min.z;*/
						var localBox = new THREE.Box3().setFromObject(collidableObjs[i]);
						//localBox.expandByScalar(-0.01);
						/*var localmin = localBox.min;
						var localmax = localBox.max;
						var amount = 0.05;
						if(localmin.x > 0)
						{
							localmin.x -= amount
						}
						else
						{
							localmin.x += amount
						}
						if(localmin.z > 0)
						{
							localmin.z -= amount
						}
						else
						{
							localmin.z += amount
						}
						if(localmax.x > 0)
						{
							localmax.x -= amount
						}
						else
						{
							localmax.x += amount
						}
						if(localmax.z > 0)
						{
							localmax.z -= amount
						}
						else
						{
							localmax.z += amount
						}
						//localmin.x = 0.01 - (localmin.x);
						//localmin.z = 0.01 - (localmin.z);
						
						//localmax.x = localmax.x  - (0.01);
						//localmax.z = localmax.z - (0.01);
						
						localBox.set(localmin,localmax);
						/*localBox.expandByScalar(-0.1);
						localBox.min.y = localmin.y;
						localBox.max.y = localmin.y;*/
						//var localCenterPoint = localBox.center();
						//var localhalfDistanceX = (voxelMX - voxelmX);
						//var localhalfDistanceZ = (voxelMZ - voxelmZ);
			
						var intersection = localBox.isIntersectionBox(boxToCheck);//localBox.containsPoint(globalVertex);
						if(intersection)
						{
							return false;
							/*var material = new THREE.MeshBasicMaterial({ color: 0x178cc8 });
							material.side = THREE.DoubleSide;
							var radius = 10; 
							var segments = 32; 
							var circleGeometry = new THREE.CircleGeometry( radius, segments); 
							var circle = new THREE.Mesh( circleGeometry, material );
							circle.position.set(tmpVertext );
							this.scene.add( circle );
							
							this.render();*/
							// #  Custom function for the following
							/*
							
								If single room is being checked for against an object being added
								If a 1x2 or 1x3 is being added and checked against a single room (1x1)
							
							
							*/
							if(collidableObjs[i].roomID == 1 && (this.room.roomID != 1 || this.room.roomID == 3 || this.room.roomID == 2))
							{
								
								/*intersection = localBox.isIntersectionBox(boxToCheck);
								if(intersection)
								{
									return false;
								}*/
								tmpVertext = resetVertext.clone();
								tmpVertext.x += 0.01;
								tmpVertext.z += 0.01;
								intersection = localBox.containsPoint(tmpVertext);
							
								if(intersection == true )
								{
								//	return false;
								}
							
								
								//if(this.intersects(localBox,boxToCheck))
							}
							else{
								
								tmpVertext = resetVertext.clone();
								tmpVertext.x += 1;
								tmpVertext.z += 1;
								intersection = localBox.containsPoint(tmpVertext);
								if(intersection)
								{
									return false;
								}
								
							}
							
							// #  Fix issue where if we put a block right next to the current block, it returns false.  We need to compare the center point with the box being added - center point distance to point
							/*for (var localvertexIndex = 0; localvertexIndex < collidableObjs[i].geometry.vertices.length; localvertexIndex++)
							{
								var tmpVertex = collidableObjs[i].geometry.vertices[localvertexIndex].clone();
								var tmpglobalVertex = tmpVertex.applyMatrix4( collidableObjs[i].matrix );
								if(tmpglobalVertex == globalVertex)
								{
									toReturn = true;
								}
								else
								{
									toReturn =  false;	
								}
							}
							/*intersection = localBox.isIntersectionBox(boxToCheck);
							if(intersection)
							{
								return false;
							}*/
							
							
							
							
						}
					}
				}
			}
			
			// #################
			// #################
			
			// VERY INTENTENSIVE COLLISION CHECK - GOES POINT BY POINT OF AN OBJECT - TAKES HEAVY TOLL ON SYSTEM
			
			// #################
			// #################
			//lets get our voxel min and max vars
			/*var voxelMX = voxel.geometry.boundingBox.max.x;
			var voxelMZ = voxel.geometry.boundingBox.max.z;
			var voxelmX = voxel.geometry.boundingBox.min.x;
			var voxelmZ = voxel.geometry.boundingBox.min.z;
				// we need to get our voxel position ad to do some math to see if voxel min and max do not go beyound our boundries for our plane
			var voxelPX = voxel.position.x;
			var voxelPY = voxel.position.y;
			var voxelPZ = voxel.position.z;
			
			var totalPositionVoxelminZ = (voxelPZ + voxelmZ);
			var totalPositionVoxelminX = (voxelPX + voxelmX);
			var totalPositionVoxelMAXZ = (voxelPZ + voxelMZ);
			var totalPositionVoxelMAXX = (voxelPX + voxelMX);*/
			// start loop for object to add Z cordinate
			/*for(var length = totalPositionVoxelminZ; length < totalPositionVoxelMAXZ; length++)
			{
				// start loop for object to add X cordinate
				for(var width = totalPositionVoxelminX; width < totalPositionVoxelMAXX; width++)
				{
					for(var i = 0; i < collidableObjs.length;i++)
					{
						//lets get our voxel min and max vars
						var thisvoxelMX = collidableObjs[i].geometry.boundingBox.max.x;
						var thisvoxelMZ = collidableObjs[i].geometry.boundingBox.max.z;
						var thisvoxelmX = collidableObjs[i].geometry.boundingBox.min.x;
						var thisvoxelmZ = collidableObjs[i].geometry.boundingBox.min.z;
							// we need to get our voxel position ad to do some math to see if voxel min and max do not go beyound our boundries for our plane
						var thisvoxelPX = collidableObjs[i].position.x;
						var thisvoxelPZ = collidableObjs[i].position.z;
						
						var thistotalPositionVoxelminZ = (thisvoxelPZ + thisvoxelmZ);
						var thistotalPositionVoxelminX = (thisvoxelPX + thisvoxelmX);
						var thistotalPositionVoxelMAXZ = (thisvoxelPZ + thisvoxelMZ);
						var thistotalPositionVoxelMAXX = (thisvoxelPX + thisvoxelMX);
						
						for(var insideZ = thistotalPositionVoxelminZ; insideZ < thistotalPositionVoxelMAXZ; insideZ++)
						{
							for(var insideX = thistotalPositionVoxelminX; insideX < thistotalPositionVoxelMAXX; insideX++)
							{
								if(insideZ == length && insideX == width)
								{
									return false;	
								}
							}
						}
					}
				}
				
			}*/
				
			return true;
		},
		render: function() {
		 	this.renderer.render( this.scene, this.camera.cam );
		},
		/**
		 * Clears all spaces populated on floor
		 */
		clearFloor: function() {
			// TODO
		},
		clearTmpHover: function() {
			// #  Clear all tmp blocks
			for(var i = 0; i < this.tmpBlocks.length; i++)
			{
				this.scene.remove( this.tmpBlocks[i] );
			}
			// #  Re-render our screen
			this.render();
		},
		zoomIn: function(event) {
			// #  Handle which view we are currently viewing in
			
			/*// #  Bird Eye View - DEPRECATED - MOVED TO ORBIT CONTROLS
			if(this.camera.cam.positionID == 2)
		  	{
				this.camera.cam.position.y = this.camera.cam.position.y - 100;
			}
			// #  Side View
			else if(this.camera.cam.positionID == 1)
			{
				this.camera.radious -= 100;
				this.camera.cam.position.x = this.camera.radious * Math.sin( this.camera.theta * Math.PI / 360 ) * Math.cos( this.camera.phi * Math.PI / 360 );
				this.camera.cam.position.y = this.camera.radious * Math.sin( this.camera.phi * Math.PI / 360 );
				this.camera.cam.position.z = this.camera.radious * Math.cos( this.camera.theta * Math.PI / 360 ) * Math.cos( this.camera.phi * Math.PI / 360 );	
			}
			*/
			this.controls.constraint.dollyOut(0.95); // zoom out
			this.controls.update();		
			this.render();

		},
		zoomOut: function() {
			
			// #  Handle which view we are currently viewing in
			
			/*// #  Bird Eye View DEPRECATED
			if(this.camera.cam.positionID == 2)
		  	{
				this.camera.cam.position.y = this.camera.cam.position.y + 100;
			}
			// #  Side View
			else if(this.camera.cam.positionID == 1)
			{
				this.camera.radious += 100;
				this.camera.cam.position.x = this.camera.radious * Math.sin( this.camera.theta * Math.PI / 360 ) * Math.cos( this.camera.phi * Math.PI / 360 );
				this.camera.cam.position.y = this.camera.radious * Math.sin( this.camera.phi * Math.PI / 360 );
				this.camera.cam.position.z = this.camera.radious * Math.cos( this.camera.theta * Math.PI / 360 ) * Math.cos( this.camera.phi * Math.PI / 360 );
			}*/
			this.controls.constraint.dollyIn(0.95); // zoom out
			this.controls.update();	
			
			this.render();
		},
		rotateLeft: function() {
			this.controls.constraint.rotateLeft(0.3);
			this.controls.update();	
			
			this.render();
		},
		rotateRight: function() {
			this.controls.constraint.rotateLeft(-0.3);
			this.controls.update();	

			this.render();
		},
		toggleFreeRoam: function() {
			var onOff = this.controls.enabled ? false : true;
			this.controls.enabled = onOff;
			this.controls.update();	
		},
		// #  Creates the grid layout
		createGridWireFrame: function() {
			var floorPlan = floorPlanRenderer;
			this.floorPlanObj = floorPlan;

			this.floorGrid = this.floorPlanObj.createLevelViewGrid(this.camera,"level-overview",50,400,this.levelHandler.buildingData.buildingMetaData.building_floor_plan_data.floor_plan_model);
		},
		clearSelectedSpaceState: function(uuid) {

			var resultObject = this.searchUUID(uuid, this.sensorsArray);
			if(resultObject != undefined) {
				this.scene.remove( resultObject.obj );

				resultObject.obj.material.map = resultObject.obj.colorNormal;
				resultObject.obj.material.map.needsUpdate = true;

				this.scene.add(resultObject.obj);
				this.render();
				return;
			}

			var resultObject = this.searchUUID(uuid, this.rooms);
			if(resultObject === undefined || (resultObject.obj.isSensor && resultObject.obj.isSensor == true)) {
				return;
			}
			this.scene.remove( resultObject.obj );
			this.rooms[resultObject.index].material.color.setHex(this.rooms[resultObject.index].colorNormal);

			resultObject = this.searchUUID(uuid, this.blocks);
			this.blocks[resultObject.index].material.color.setHex(this.blocks[resultObject.index].colorNormal);
			this.scene.add(resultObject.obj);

			this.render();
		},
		/**
		 * TODO: move to helper file
		 */
		searchUUID: function(value, myArray){
			for (var i=0; i < myArray.length; i++) {
				if (myArray[i].uuid === value) {
					return {
						'obj': myArray[i],
						'index': i
					};
				}
			}
		},
		/**
		 * Locates and reloads space based on uuid
		 */
		reloadSpace: function(uuid, colorHex) {
			if(colorHex === undefined) {
				colorHex = this.room.colorNormal;
			}

			var resultObject = this.searchUUID(uuid, this.sensorsArray);
			if(resultObject != undefined) {
				this.scene.remove( resultObject.obj );

				resultObject.obj.material.map = resultObject.obj.hoverColor;
				resultObject.obj.material.map.needsUpdate = true;

				this.scene.add(resultObject.obj);
				this.render();
				return;
			}

			var resultObject = this.searchUUID(uuid, this.blocks);
			if(resultObject == undefined || resultObject.obj.sensorActive == parseInt(1)) {
				return;
			}

			this.scene.remove( resultObject.obj );
			resultObject.obj.colorNormal = colorHex;
			this.blocks[resultObject.index].colorNormal = colorHex;
			// TODO: correct this to actually make the color change
			// this.blocks[resultObject.index].material.color.setHex(colorHex);

			// resultObject = this.searchUUID(uuid, this.rooms);
			// this.rooms[resultObject.index].colorNormal = colorHex;
			// this.rooms[resultObject.index].material.color.setHex(colorHex);
			this.scene.add(resultObject.obj);

			this.render();
		},
		disableSensor: function(uuid) {
			var resultObject = this.searchUUID(uuid, this.blocks);
			if(resultObject === undefined) {
				return;
			}
			this.scene.remove(resultObject.obj);
			this.blocks[resultObject.index].sensorActive = 0;

			resultObject = this.searchUUID(uuid, this.rooms);
			this.rooms[resultObject.index].sensorActive = 0;

			this.activeWindowTimeout.forEach(timeout => {
				window.clearTimeout(timeout);
			});

			this.activeWindowTimeout = [];

			this.displayActiveSensorColorChange;
		},
		clearWindowTimeouts: function() {
			this.activeWindowTimeout.forEach(timeout => {
				window.clearTimeout(timeout);
			});

			this.activeWindowTimeout = [];
		},
				/**
		 * Locates and reloads space based on uuid
		 */
		reloadSpaceVersionTwo: function(uuid, colorHex, isClose = false) {
			if(colorHex === undefined) {
				colorHex = this.room.colorNormal;
			}

			var resultObject = this.searchUUID(uuid, this.blocks);
			if(resultObject === undefined) {
				return;
			}

			if(this.lastSpace != null && resultObject.obj.uuid == this.lastSpace.uuid && !isClose) {
				if(resultObject.obj.sensorActive == 0) {
					colorHex = this.room.colorHover;
				}
			}

			this.scene.remove( resultObject.obj );
			this.blocks[resultObject.index].material.color.setHex(colorHex);

			resultObject = this.searchUUID(uuid, this.rooms);
			this.rooms[resultObject.index].material.color.setHex(colorHex);
			this.scene.add(resultObject.obj);

			this.render();
		},
		reloadSensorAsset: function(uuid, alert) {
			var resultObject = this.searchUUID(uuid, this.sensorsArray);
			if(resultObject != undefined) {
				if(resultObject.obj.alertActive == 1 && alert || resultObject.obj.alertActive == 0 && !alert) {
					return;
				}
				if(alert) {
					resultObject.obj.material.map = resultObject.obj.colorAlert;
					resultObject.obj.alertActive = 1;
				} else {
					resultObject.obj.material.map = resultObject.obj.colorNormal;
					resultObject.obj.alertActive = 0;
				}
				resultObject.obj.material.map.needsUpdate = true;
				this.render();
			}
		},
		removeSpace: function(uuid) {
			var resultObject = this.searchUUID(uuid, this.sensorsArray);
			if(resultObject != undefined) {
				this.scene.remove( resultObject.obj );
				this.sensorsArray.splice(resultObject.index, 1);
				this.render();
				return;
			}
			var resultObject = this.searchUUID(uuid, this.blocks);
			if(resultObject === undefined) {
				return;
			}

			this.scene.remove( resultObject.obj );
			this.blocks.splice(resultObject.index, 1);
			resultObject = this.searchUUID(uuid, this.rooms);
			if(resultObject != undefined) {
				this.rooms.splice(resultObject.index, 1);
			}

			this.render();
		},
		// #  This is a crucial function that is what is used to pass building data and populate the unit into the grid.
		populateSpaces: function(spaces) {
			if(spaces === undefined) {
				return;
			}
			// #  Loop through each space
			for(var i = 0; i < spaces.length; i++)
			{
				var space_specs = spaces[i].space_3d_build_data;
				var space_details = spaces[i].space_data;
				var space_color_coding = spaces[i].space_color_coding;
				var sensor_data = spaces[i].sensor_data;

				if(space_details.space_abbreviation == 'watersensor' || space_details.space_abbreviation == 'doorsensor' || space_details.space_abbreviation == 'firealarm'
					|| space_details.space_abbreviation == 'tempsensor') {
					this.populateSensor(spaces[i]);
				} else {
					// #  Lets check our space abbreviation to set the active room type
					var roomGeometry = this.room.getGeometry(space_details.space_abbreviation);
					var roomMaterial = this.room.getMaterial(space_details.space_abbreviation,space_color_coding);
					var divideScalar = this.room.getDivideScalar(space_details.space_abbreviation);
					var multiplyScalar = this.room.getMultiplyScalar(space_details.space_abbreviation);
					var addScalar = this.room.getAddScalar(space_details.space_abbreviation);
					var roomID = this.room.getRoomID(space_details.space_abbreviation);
					var roomType = space_details.space_abbreviation;
					var additionalZ = this.room.getAdditionalZ(space_details.space_abbreviation);
					var additionalX = this.room.getAdditionalX(space_details.space_abbreviation);
					// #  Set up our world position values
					var localX = space_specs.world_x, localY = space_specs.world_y, localZ = space_specs.world_z;
					var voxel = new THREE.Mesh( roomGeometry, roomMaterial );
					voxel.geometry.computeBoundingBox();
					// now lets do some custom modification of position for objects to handle snapping effect
					voxel.position.z = localZ;
					voxel.position.y = localY;
					voxel.position.x = localX;
					voxel.position.divideScalar( divideScalar ).floor().multiplyScalar( multiplyScalar ).addScalar( addScalar );

					// now lets do some custom modification of position for objects to handle snapping effect
					voxel.position.z -= additionalZ;
					voxel.position.x -= additionalX;
					// #  Lets check to see if we have any colors for this space
					if(!space_color_coding)
					{
						voxel.colorNormal = this.room.colorNormal;
					}
					else
					{
						// #  Set corresponding state
						voxel.colorNormal = space_color_coding.color_hex_code;
					}
					voxel.hoverColor  = this.room.colorHover;
					voxel.colorRemove = this.room.colorRemove;
					voxel.roomID 	  = roomID;
					voxel.spaceID 	  = space_details.space_id;
					voxel.roomType 	  = roomType;
					voxel.uuid 		  = space_specs.uuid;
					voxel.sensorUuid  = '';
					voxel.sensorActive= 0;

					if(sensor_data) {
						voxel.sensorUuid   = sensor_data.sensor_uuid;
						voxel.sensorActive = sensor_data.active;
						if(voxel.sensorActive == parseInt(1)) {
							this.activeSensors.push(voxel);
						}
					}

					this.domEvents.addEventListener(voxel, 'mouseover', this.onDocumentMouseOverCube.bind(this),false);
					this.domEvents.addEventListener(voxel, 'mouseout', this.onDocumentMouseOutCube.bind(this),false);
					this.domEvents.addEventListener(voxel, 'click', this.onDocumentMouseOutClick.bind(this),false);

					this.scene.add(voxel);
					this.blocks.push(voxel);
					this.rooms.push(voxel);

					if(this.levelHandler.context.state.spaceID !== undefined && voxel.spaceID == this.levelHandler.context.state.spaceID) {
						this.manualMouseOutClick(voxel);
					}
				}
			}
			this.displayActiveSensorColorChange();
			this.displayActiveSensorAssetChange();
			// #  render screen
			this.render();
		},
		populateSensor: function(space) {
			var space_specs = space.space_3d_build_data;
			var space_details = space.space_data;
			var sensor_data = space.sensor_data;
			var self = this;
			// #  Lets check our space abbreviation to set the active room type
			var roomGeometry = this.sensorHandler.getGeometry(space_details.space_abbreviation);
			this.sensorHandler.getMaterial(space_details.space_abbreviation, function(roomMaterial, colorNormal, colorHover, colorAlert = null) {
				var divideScalar = self.sensorHandler.getDivideScalar(space_details.space_abbreviation);
				var multiplyScalar = self.sensorHandler.getMultiplyScalar(space_details.space_abbreviation);
				var addScalar = self.sensorHandler.getAddScalar(space_details.space_abbreviation);
				var roomID = self.sensorHandler.getRoomID(space_details.space_abbreviation);
				var roomType = space_details.space_abbreviation;
				var additionalZ = self.sensorHandler.getAdditionalZ(space_details.space_abbreviation);
				var additionalX = self.sensorHandler.getAdditionalX(space_details.space_abbreviation);
				// #  Set up our world position values
				var localX = space_specs.world_x, localY = space_specs.world_y, localZ = space_specs.world_z;
				var voxel = new THREE.Mesh( roomGeometry, roomMaterial );
				voxel.geometry.computeBoundingBox();
				// now lets do some custom modification of position for objects to handle snapping effect
				voxel.position.z = localZ;
				voxel.position.y = 5;
				voxel.position.x = localX;
				voxel.position.divideScalar( divideScalar ).floor().multiplyScalar( multiplyScalar ).addScalar( addScalar );

				// now lets do some custom modification of position for objects to handle snapping effect
				voxel.position.z -= additionalZ;
				voxel.position.x -= additionalX;

				voxel.colorNormal = colorNormal;
				voxel.hoverColor  = colorHover;
				voxel.colorAlert  = colorAlert;
				voxel.colorRemove = self.sensorHandler.colorRemove;
				voxel.roomID 	  = roomID;
				voxel.spaceID 	  = space_details.space_id;
				voxel.roomType 	  = roomType;
				voxel.uuid 		  = space_specs.uuid;
				voxel.sensorUuid  = '';
				voxel.sensorActive= 0;
				voxel.alertActive = 0;
				voxel.isSensor    = true;

				if(sensor_data) {
					voxel.sensorUuid   = sensor_data.sensor_uuid;
					voxel.sensorActive = sensor_data.active;
					if(voxel.sensorActive == parseInt(1)) {
						self.activeSensors.push(voxel);
					}
				}
				self.domEvents.addEventListener(voxel, 'mouseover', self.onDocumentMouseOverCube.bind(self),false);
				self.domEvents.addEventListener(voxel, 'mouseout', self.onDocumentMouseOutCube.bind(self),false);
				self.domEvents.addEventListener(voxel, 'click', self.onDocumentMouseOutSensorClick.bind(self),false);

				var duplicateFound = false;
				var newCopy = [];
				self.sensorsArray.forEach(element => {
					if(element.uuid && element.uuid == voxel.uuid) {
						duplicateFound = true;
					} else {
						newCopy.push(element);
					}
				});

				self.rooms = newCopy;

				if(!duplicateFound) {
					self.scene.add(voxel);
					self.sensorsArray.push(voxel);
				}

				if(self.levelHandler.context.state.spaceID !== undefined && voxel.spaceID == self.levelHandler.context.state.spaceID) {
					self.manualMouseOutClickSensor(voxel);
				}
				self.render();
			});
		},
		saveSpace: function(voxel, callback)
		{
			if(this.sensorHandler.isActive) {
				var data = {
					'level_number' : this.levelHandler.buildingData.levelID,
					'building_id' : this.levelHandler.buildingData.buildingID,
					'UUID' : voxel.uuid,
					'world_x' : voxel.position.x,
					'world_y' : voxel.position.y,
					'world_z' : voxel.position.z,
					'space_abbreviation': voxel.roomType,
					'isSensor': true,
					'type': voxel.roomType
				};
				spaces.saveSpace(data, callback);
			} else {
				var data = {
					'level_number' : this.levelHandler.buildingData.levelID,
					'building_id' : this.levelHandler.buildingData.buildingID,
					'UUID' : voxel.uuid,
					'world_x' : voxel.position.x,
					'world_y' : voxel.position.y,
					'world_z' : voxel.position.z,
					'space_abbreviation': voxel.roomType,
					'isSensor': false
				};
				spaces.saveSpace(data, callback);
			}

			// Maybe add a callback?


			/*// #  Prepare our data to be sent server
			// #  Localize this instance for use on success
			var self = this;
			// prepare our data to be sent
			var url = "spaces";
			var params = {
				'action': 'saveBuildingLevelSpace', 
				'module' : 'BuildingLevel', 
				'level_number' : this.routingObject.userObject.activeFloor.floor_number, 
				'building_id' : this.routingObject.userObject.activeBuilding.buildingID,
				'UUID' : voxel.uuid,
				'world_x' : voxel.position.x,
				'world_y' : voxel.position.y,
				'world_z' : voxel.position.z,
				'space_abbreviation': voxel.roomType
			};
			var object = this;
			// #  Send to server object for processing
			var data = this.server.getData(url,params,false);
			// #  Listen to our data
			data
			.done(function(response){
				// #  Validate response
				if(response.status == 1 || response.status == 2)
				{
				}
				else
				{
					if('error' in response.data)
					{
						// #  Nothing here
						return;
					}
					else
					{
						// #  Notifiy the ui that a save was just updated
						// #  update active floor level property
						self.routingObject.userObject.activeFloor['last_updated'] = response.data.last_updated;
						// #  forces gui to refresh
						self.levelRenderer.manualLastUpdate();
					}
				}
			})
			.fail(function(e){
				console.log(e);
			});*/
		},
		toggleEditMode: function(editModeState) {
			if(editModeState == "active") {
				this.editMode = true;
			} else {
				this.editMode = false;
				// remove any overlaying shapes
				this.clearTmpHover();
			}
		},
		displayActiveSensorColorChange: function() {
			var self = this;
			this.activeSensors.forEach(voxel => {
				const startColor = voxel.colorNormal;
				const endColor   = 0xF1C232;
				var didChange    = false;

				var timeout = window.setInterval(function(){
					didChange = didChange ? false : true;
					self.reloadSpaceVersionTwo(voxel.uuid, didChange ? startColor : endColor);
				}, 1000);

				self.activeWindowTimeout.push(timeout);
			});
		},
		displayActiveSensorAssetChange: function() {
			var self = this;
			var timeout = window.setInterval(function(){
				self.sensorsArray.forEach(voxel => {
					if(voxel.roomType != 'tempsensor') {
						sensors.getSensorAssetChange(voxel.uuid);
					}
				});
			}, 10000);

			self.activeWindowTimeout.push(timeout);
		},
		toggleRenderType: function() {
			if(this.sensorHandler.isActive) {
				this.room = sensorRenderer;
			} else {
				this.room = roomRenderer;
			}
		},
		cleanSpacesAndSensors: function(callback) {
			var self = this;
			this.blocks.forEach(element => {
				self.scene.remove(element);
			});

			this.blocks = [];
			this.rooms= [];
			callback();
		}
});

export let levelRenderer = new LevelRenderer();


// WEBPACK FOOTER //
// app/core/graphic_engine/controllers/LevelRenderer.js